import { render, staticRenderFns } from "./ReviewFlags.vue?vue&type=template&id=20260072&"
import script from "./ReviewFlags.vue?vue&type=script&lang=js&"
export * from "./ReviewFlags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports